export class Stock {
  id: number
  branch: number
  article: number
  quantity: number
  date: Date

  constructor(props: Stock) {
    Object.assign(this, props)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Stock/Model.ts